import { render, staticRenderFns } from "./support-item.vue?vue&type=template&id=447b6f8a&scoped=true&"
import script from "./support-item.vue?vue&type=script&lang=js&"
export * from "./support-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447b6f8a",
  null
  
)

export default component.exports